import React, { useEffect, useState } from 'react';
import './menuiteams.css';

import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ArrowBack from "@mui/icons-material/ArrowBack";

import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";

// Set the app element for accessibility
Modal.setAppElement('#root');
const MenuitemsTable = ({ setShowLogin, parentId, searchQuery }) => {
    const [dishes, setDishes] = useState([]);
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDish, setSelectedDish] = useState(null);
    const [cartItems, setCartItems] = useState([" "]); // State to store multiple cart items
    const [isHovered, setIsHovered] = useState(false);  // Track hover state
    const navigate = useNavigate();
    const [enable, setEnable] = useState([]);
    const [activeTooltip, setActiveTooltip] = useState(null); // keeps track of which dish's tooltip is open
    const [description, setDescription] = useState(""); // ✅ define state here
    const [isDineIn, setIsDineIn] = useState(true);
    const [isTakeAway, setIsTakeAway] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [searchTerm, setSearchTerm] = useState(""); // ✅ ADD THIS
    const [orderType, setOrderType] = useState(null);

    useEffect(() => {
        if (!Array.isArray(dishes)) return;

        const searchValue = searchTerm.toLowerCase().trim();

        if (searchValue === "") {
            setFilteredDishes(dishes); // reset
        } else {
            const searched = dishes.filter(
                (item) =>
                    item?.dishName &&
                    item.dishName.toLowerCase().includes(searchValue)
            );

            setFilteredDishes(searched);
        }
    }, [searchTerm, dishes]);



    const handleVegNonVegToggle = () => {
        if (isVegSelected) {
            handleFilterClick("Non-Veg");
        } else {
            handleFilterClick("Veg");
        }
    };


    useEffect(() => {
        handleFilterClick("ALL"); // ✅ sab dishes
    }, [dishes]);




    const handleNavigate = () => {
        navigate("/cartsdata");
    };


    const handleToggleTooltip = (dishName, description) => {
        if (activeTooltip === dishName) {
            setActiveTooltip(null);
            setDescription(""); // 
        } else {
            setActiveTooltip(dishName);
            setDescription(description || "");
        }
    };

    const handleFilterClick = (type) => {

        if (type === "ALL") {
            // ✅ Default: show all dishes
            setIsVegSelected(false);
            setIsNonVegSelected(false);
            setFilteredDishes(dishes);
            return;
        }

        if (type === "Veg") {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
            setFilteredDishes(
                dishes.filter(dish => dish.tag === "Veg")
            );
        } else if (type === "Non-Veg") {
            setIsVegSelected(false);
            setIsNonVegSelected(true);
            setFilteredDishes(
                dishes.filter(dish => dish.tag === "Non_Veg")
            );
        }
    };

    const totalPrice = cartItems.reduce((acc, item) => {
        return acc + item.price * item.quantity * 0.9; // applying 10% discount
    }, 0);

    const handleAddToFavorites = async (dishId) => {
        // ////console.log("🟢 handleAddToFavorites RECEIVED parameter:", dishId);
        // //////console.log("Type of dishId:", typeof dishId);

        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId || !token) {
            alert("Please log in to add items to favorites.");
            return;
        }

        // Verify the dish exists
        const dish = dishes.find(d => d.dishId === dishId);
        //////console.log("Dish verification - Looking for dishId:", dishId);
        //////console.log("Found dish:", dish);

        if (!dish) {
            console.error("❌ Dish not found for ID:", dishId);
            alert(`Error: Dish ID ${dishId} not found.`);
            return;
        }

        const apiUrl = ` https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`;
        //////console.log("📤 Final API URL:", apiUrl);

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const responseText = await response.text();
            //////console.log("📄 Response:", responseText);

            if (response.ok) {
                alert(`✅ "${dish.dishName}" added to favorites!`);
            } else if (response.status === 404) {
                alert(`❌ "${dish.dishName}" not found in system.`);
            } else if (response.status === 409) {
                alert("❤️ Already in favorites!");
            } else {
                alert(`❌ Error: ${responseText}`);
            }

        } catch (error) {
            console.error("Network error:", error);
            alert("❌ Network error.");
        }
    };

    const [isOn, setIsOn] = useState(false);
    // //////console.log('parentId:', parentId); // 🔍 Check if `parentId` is correctly passed
    const userId = localStorage.getItem('userId'); // check login status

    const addToCart = async (item, quantity = 1) => {
        // console.log("addToCart called with dishId:", item.dishId);

        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId) {
            setShowLogin(true);
            return;
        }

        if (!token) {
            alert("Please log in to add items to cart.");
            return;
        }

        // ✅ SIMPLE: Just try to add the item directly
        const addItemUrl = ` https://backend.maamaas.com/food/api/cart/add/${userId}`;
        const data = {
            dishId: item.dishId,
            quantity: quantity,
        };

        try {
            const response = await axios.post(addItemUrl, data, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                // console.log("✅ Item successfully added to cart:", response.data);

                // Update local state
                setCartItems((prevItems) => {
                    const existingItem = prevItems.find(
                        (cartItem) => cartItem.dishId === item.dishId
                    );
                    if (existingItem) {
                        return prevItems.map((cartItem) =>
                            cartItem.dishId === item.dishId
                                ? { ...cartItem, quantity }
                                : cartItem
                        );
                    } else {
                        return [...prevItems, { ...item, quantity }];
                    }
                });

                setIsModalOpen(true);
                setTimeout(() => {
                    if (!isHovered) {
                        setIsModalOpen(false);
                    }
                }, 2000);
            }
        } catch (error) {
            console.error("❌ Error adding item to cart:", error);

            // Show specific error message
            if (error.response?.status === 500) {
                alert("Please choose an order type (Dine In / Takeaway) to continue.");

            } else {
                alert("Failed to add item to cart. Please try again.");
            }
        }
    };

    // ✅ NEW FUNCTION: Check if cart exists
    // ✅ FIXED: Properly check if cart exists with items
    const checkCartExists = async (userId, token) => {
        try {
            const checkCartUrl = ` https://backend.maamaas.com/food/api/cart/${userId}/without-seating`;
            const response = await axios.get(checkCartUrl, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // console.log("🛒 Cart check response:", response.data);

            // ✅ PROPER CHECK: Cart exists only if it has data
            if (Array.isArray(response.data) && response.data.length > 0) {
                // Array response - check if first cart has items
                const hasItems = response.data[0]?.cartItems?.length > 0;
                // console.log("🛒 Cart exists with array format, has items:", hasItems);
                return hasItems;
            } else if (response.data && response.data.cartItems) {
                // Object response - check if cart has items
                const hasItems = response.data.cartItems.length > 0;
                // console.log("🛒 Cart exists with object format, has items:", hasItems);
                return hasItems;
            } else if (response.data) {
                // Direct cart items array
                const hasItems = response.data.length > 0;
                // console.log("🛒 Cart exists with direct format, has items:", hasItems);
                return hasItems;
            }

            // console.log("🛒 Cart exists but is empty");
            // return false;

        } catch (error) {
            // Only return false if backend says "not found"
            if (error.response?.status === 404) {
                // console.log("🛒 No cart exists (404)");
                return false;
            }
            // console.error("Error checking cart existence:", error);
            // Don't recreate cart if it's a temporary issue
            return true; // Assume cart exists to avoid creating duplicates
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const userId = localStorage.getItem("userId"); // or however you store it
            const token = localStorage.getItem("token");   // this fixes 'token' undefined

            // console.log("🧭 Menu mounted — fetching cart...");
            // console.log("UserId:", userId);
            // console.log("Cart before fetch:", cart);

            const exists = await checkCartExists(userId, token);

            if (!exists) {
                // console.log("🧩 Creating new cart...");
                await createNewCart(userId, token);
            } else {
                // console.log("✅ Cart already exists, not creating a new one.");
            }

            // Then continue with fetching menu items, etc.
        };

        fetchData();
    }, []);

    // ✅ FIXED: Create cart with required orderType
    const createNewCart = async (userId, token) => {
        try {
            const createCartUrl = ` https://backend.maamaas.com/food/api/cart/create/${userId}`;

            // ✅ ADD orderType in the request body
            const cartData = {
                orderType: "TAKEAWAY" // or "DINE_IN" depending on your needs
            };

            // console.log("🔄 Creating new cart with data:", cartData);

            const response = await axios.post(createCartUrl, cartData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            // console.log("✅ New cart created:", response.data);
            return response.data;
        } catch (error) {
            // console.error("❌ Failed to create cart:", error);
            // console.error("Error details:", error.response?.data);
            throw error;
        }
    };



    const handleOrderTypeClick = async (selectedType) => {
        console.log("🟢 Order Type Clicked:", selectedType);

        // prevent unnecessary API call
        if (orderType === selectedType) return;

        // 🔔 ALERT ONLY FOR DELIVERY


        try {
            const userId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken");

            if (!userId || !token) {
                alert("Please login first");
                return;
            }

            // UI update first
            setOrderType(selectedType);

            const apiUrl = ` https://backend.maamaas.com/food/api/cart/create/${userId}/orderType/${selectedType}`;

            await axios.put(
                apiUrl,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("✅ Order Type Updated in Cart:", selectedType);

        } catch (error) {
            console.error("❌ Failed to update order type", error);
        }
    };

    // Function to update cart order type
    const updateCartOrderType = async (userId, token, newOrderType) => {
        try {
            const cartExists = await checkCartExists(userId, token);

            if (cartExists) {
                const updateCartUrl = ` https://backend.maamaas.com/food/api/cart/update-order-type/${userId}?orderType=${newOrderType}`;

                const response = await axios.put(updateCartUrl, null, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });

                //////console.log("✅ Cart order type updated:", response.data);
                return response.data;
            } else {
                const newCart = await createNewCart(userId, token, newOrderType);
                return newCart;
            }
        } catch (error) {
            console.error("❌ Failed to update cart order type:", error);
            throw error;
        }
    };


    // ✅ Keep your existing createNewCart function but ONLY use it when needed
    // const createNewCart = async (userId, token) => {
    //     try {
    //         const createCartUrl = ` https://backend.maamaas.com/food/api/cart/create/${userId}`;
    //         const response = await axios.post(createCartUrl, {}, {
    //             headers: {
    //                 "Authorization": `Bearer ${token}`,
    //                 "Content-Type": "application/json"
    //             }
    //         });
    //         ////console.log("✅ New cart created:", response.data);
    //         return response.data;
    //     } catch (error) {
    //         console.error("❌ Failed to create cart:", error);
    //         throw error;
    //     }
    // };
    // const checkCartExists = async (userId, token) => {
    //     try {
    //         const checkCartUrl = ` https://backend.maamaas.com/food/api/cart/${userId}/without-seating`;
    //         const response = await axios.get(checkCartUrl, {
    //             headers: { Authorization: `Bearer ${token}` },
    //         });

    //         // ✅ Cart exists if we got a 200, even if it's empty
    //         ////console.log("🛒 Cart exists check: true (200 received)");
    //         return true;
    //     } catch (error) {
    //         // Only return false if backend says "not found"
    //         if (error.response?.status === 404) {
    //             ////console.log("🛒 No cart exists (404)");
    //             return false;
    //         }
    //         console.error("Error checking cart existence:", error);
    //         // ⚠️ Don't recreate cart if it's a temporary issue
    //         return true;
    //     }
    // };

    // ✅ Helper function to create cart for NORMAL menu

    const createCartAndRetry = async (item, quantity) => {
        try {
            const userId = localStorage.getItem("userId");
            const token = localStorage.getItem("authToken");

            const createCartUrl = ` https://backend.maamaas.com/food/api/cart/create/${userId}`;

            // ✅ For normal menu, use appropriate orderType (not DINE_IN)
            const cartData = {
                orderType: "TAKEAWAY" // ✅ Change this to match your backend expectation
            };

            ////console.log("🔄 Creating new cart for normal menu...", cartData);

            await axios.post(createCartUrl, cartData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            ////console.log("✅ Cart created successfully, retrying add item...");

            // Retry adding the item
            await addToCart(item, quantity);

        } catch (createError) {
            console.error("❌ Failed to create cart:", createError);
            alert("Failed to initialize cart. Please try again.");
        }
    };
    // const addToCart = async (item, quantity = 1) => {
    //     ////console.log("addToCart called with dishId:", item.dishId);

    //     const userId = localStorage.getItem("userId");
    //     const token = localStorage.getItem("authToken");

    //     if (!userId) {
    //         setShowLogin(true);
    //         return;
    //     }

    //     if (!token) {
    //         alert("Please log in to add items to cart.");
    //         return;
    //     }

    //     // ✅ SIMPLE: Just use the add API directly
    //     const apiUrl = ` https://backend.maamaas.com/food/api/cart/add/${userId}`;

    //     const data = {
    //         dishId: item.dishId,
    //         quantity: quantity,
    //     };

    //     try {
    //         const response = await axios.post(apiUrl, data, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });

    //         if (response.status === 200) {
    //             ////console.log("✅ Item successfully added to NORMAL cart:", response.data);

    //             // Update local state
    //             setCartItems((prevItems) => {
    //                 const existingItem = prevItems.find(
    //                     (cartItem) => cartItem.dishId === item.dishId
    //                 );
    //                 if (existingItem) {
    //                     return prevItems.map((cartItem) =>
    //                         cartItem.dishId === item.dishId
    //                             ? { ...cartItem, quantity }
    //                             : cartItem
    //                     );
    //                 } else {
    //                     return [...prevItems, { ...item, quantity }];
    //                 }
    //             });

    //             // Show success modal
    //             setIsModalOpen(true);
    //             setTimeout(() => {
    //                 if (!isHovered) {
    //                     setIsModalOpen(false);
    //                 }
    //             }, 2000);
    //         } else {
    //             console.error("Failed to add item to cart:", response.data);
    //         }
    //     } catch (error) {
    //         console.error("Error adding item to cart:", error);
    //         alert("Failed to add item to cart. Please try again.");
    //     }
    // };




    // useEffect(() => {
    //     const fetchData = async () => {
    //         const vendorId = localStorage.getItem("vendorId");
    //         const token = localStorage.getItem("authToken");

    //         if (!vendorId || !token) {
    //             setError(new Error("vendorId or authToken missing"));
    //             setLoading(false);
    //             return;
    //         }

    //         try {
    //             const response = await fetch(
    //                 ` https://backend.maamaas.com/food/api/dish/discount/${userId}`,
    //                 {
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                         Accept: "application/json",
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                 }
    //             );

    //             if (!response.ok) {
    //                 throw new Error(`HTTP error! status: ${response.status}`);
    //             }

    //             const text = await response.text();
    //             if (!text) {
    //                 setDishes([]);
    //                 setFilteredDishes([]);
    //                 return;
    //             }

    //             const data = JSON.parse(text);
    //             const dishData = Array.isArray(data) ? data : data.data || [];

    //             const filteredData = dishData.filter((item) => {
    //                 if (!item) return false;

    //                 const parentCheck = parentId
    //                     ? Number(item.parentId) === Number(parentId)
    //                     : Number(item.parentId) !== 0;

    //                 return (
    //                     parentCheck &&
    //                     item.menuStatus === "Enable" &&
    //                     Number(item.balanceQuantity) > 0 &&
    //                     Number(item.discount) > 0        // 🔥 ONLY DISCOUNT CHECK
    //                 );
    //             });

    //             setDishes(filteredData);
    //             setFilteredDishes(filteredData);
    //         } catch (error) {
    //             setError(error);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchData();
    // }, [parentId, userId]);



    useEffect(() => {
  const fetchData = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) {
      setError(new Error("vendorId or authToken missing"));
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        ` https://backend.maamaas.com/food/api/dish/discount/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      if (!text) {
        setDishes([]);
        setFilteredDishes([]);
        return;
      }

      const data = JSON.parse(text);
      const dishData = Array.isArray(data) ? data : data.data || [];

      const filteredData = dishData.filter((item) => {
        if (!item) return false;

        const parentCheck = parentId
          ? Number(item.parentId) === Number(parentId)
          : Number(item.parentId) !== 0;

        return (
          parentCheck &&
          item.menuStatus === "Enable" &&
          Number(item.discount) > 0
        );
      });

      setDishes(filteredData);
      setFilteredDishes(filteredData);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [parentId, userId]);




    // const handleFilterClick = (type) => {
    //     if (type === "Veg") {
    //         setIsVegSelected(true);
    //         setIsNonVegSelected(false);
    //         setFilteredDishes(dishes.filter(dish => dish.tag === "Veg"));
    //     } else {
    //         setIsVegSelected(false);
    //         setIsNonVegSelected(true);
    //         setFilteredDishes(dishes.filter(dish => dish.tag === "Non_Veg"));
    //     }
    // };






    const openModal = (dish) => {
        setSelectedDish(dish);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedDish(null);
    };

    const increaseQuantity = async (dishId) => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId) {
            alert("Please log in first.");
            return;
        }

        const newQuantity = (quantities[dishId] || 0) + 1;

        const apiUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQuantity}&dishId=${dishId}`;

        ////console.log("📤 increaseQuantity URL:", apiUrl);

        try {
            await axios.put(apiUrl, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            // Update local UI
            setQuantities((prev) => ({
                ...prev,
                [dishId]: newQuantity,
            }));

        } catch (err) {
            console.error("❌ Failed to increase quantity");
            console.error("Status:", err.response?.status);
            console.error("Data:", err.response?.data);
            console.error("Message:", err.message);

            alert(
                err.response?.data?.message ||
                "Unable to add item right now. Please try again."
            );
        }
    };

    const decreaseQuantity = async (item) => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const dishId = item.dishId;

        if (!userId || !dishId) {
            console.error("❌ Missing userId or dishId", { userId, dishId });
            return;
        }

        const currentQty = quantities[dishId] || item.quantity || 1;

        if (currentQty <= 1) {
            ////console.log("⚠️ Quantity already at minimum");
            return;
        }

        const newQty = currentQty - 1;

        const apiUrl = ` https://backend.maamaas.com/food/api/cart/update/${userId}?quantity=${newQty}&dishId=${dishId}`;

        ////console.log("📤 decreaseQuantity URL:", apiUrl);

        try {
            await axios.put(
                apiUrl,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            // ✅ Update UI
            setQuantities((prev) => ({
                ...prev,
                [dishId]: newQty,
            }));

            ////console.log(`✅ Quantity decreased: ${dishId} → ${newQty}`);
        } catch (err) {
            console.error("❌ Failed to decrease quantity");
            console.error("Status:", err.response?.status);
            console.error("Data:", err.response?.data);

            alert(
                err.response?.data?.message ||
                "Unable to decrease item quantity right now."
            );
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading dishes: {error.message}</div>;
    }
    const handleViewCartClick = () => {
        navigate('/cartsdata'); // Redirects to the cart page all rhe reflected code also not occupied in the real time code and all
    };

    return (
        <div style={{ marginTop: '16px' }} className='menuiteams-data'>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    marginBottom: "1rem",
                    justifyContent: "center",
                }}
            >
                <style>
                    {`
      @media (max-width: 600px) {
        .responsive-button-group {
          flex-direction: column !important;
          align-items: center !important;
        }
        .responsive-button {
          width: 80% !important;
          text-align: center;
        }
        .custom-switch-wrapper {
          margin-top: 40px;
        }
      }

      .custom-switch {
        position: relative;
        display: inline-block;
        width: 100px;
        height: 35px;
      }

      .custom-switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .custom-slideryy {
        position: absolute;
        cursor: pointer;
        transition: 0.4s;
        font-weight: bold;
        font-size: 14px;
        color: #000;
        text-align: center;
        line-height: 35px;
        width: 100px;
        height: 40px;
        border-radius: 5px;
        background-color: rgb(217, 217, 217);
      }

      .custom-slideryy::before {
        content: "";
        position: absolute;
        height: 16px;
        width: 16px;
        left: 3px;
        top: 10px;
        background-color: #000;
        transition: 0.4s;
        border-radius: 50%;
      }

      .custom-slideryy.veg::before {
        background-color: green;
        font
      }

      .custom-slideryy.non-veg::before {
        background-color: red;
      }

      .custom-switch input:checked + .custom-slideryy::before {
        transform: translateX(60px);
      }
        @media (max-width: 600px) {
  .responsive-button-group {
    flex-direction: column !important;
    align-items: center !important;
  }

  .responsive-button {
    width: 100% !important; /* ✅ Increased width */
    text-align: center;
  }

  .custom-switch-wrapper {
    margin-top: -62px;
    width: 90%; /* Optional: match button width */
    display: flex;
    justify-content: center;
  }
    
}

    `}
                </style>
                <style>
                    {`
/* Container */
.menu-responsive-buttons-code {
  width: 100%;
}

/* Button wrapper */
.order-filter-buttons {
  display: flex;
  gap: 14px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 16px;
 
  border-radius: 14px;
  
}

/* Common button style */
.btn-filter {
  min-width: 115px;
  padding: 10px 22px;
  border-radius: 12px;
  border: none;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: all 0.25s ease;
}

/* Green (Veg / DINE_IN) */
.btn-filter.green {
  background: gry;
  color: black;
}

// .btn-filter.green:hover {
//   transform: translateY(-2px);
//   box-shadow: 0 6px 14px rgba(7, 150, 92, 0.25);
// }

/* Active Green */
.btn-filter.active-green {
  background: green;
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(22, 163, 74, 0.4);
}

/* Red (Non-Veg / Takeaway) */
// .btn-filter.red {
//   background: linear-gradient(145deg, #ffe4e6, #fecdd3);
//   color: #9f1239;
//   font-size:20px;
//   font-wieghet:"bold;
// }

// .btn-filter.red:hover {
//   transform: translateY(-2px);
//   box-shadow: 0 6px 14px rgba(190, 24, 93, 0.25);
// }

/* Active Red */
.btn-filter.active-red {
  background: linear-gradient(145deg, #dc2626, #991b1b);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(220, 38, 38, 0.45);
}

.blue {
    background-color: #e3f2fd;
    color: #1565c0;
}

.active-blue {
    background-color: #1565c0;
    color: white;
}

/* Back button */
.custom-switch-wrapper button:first-child {
  font-weight: 600;
  transition: color 0.2s ease;
}

.custom-switch-wrapper button:first-child:hover {
  color: #7c3aed;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .order-filter-buttons {
    gap: 10px;
    padding: 12px;
    margin-top: 42px;
  }
    

  .btn-filter {
    min-width: 100px;
    font-size: 14px;
    padding: 9px 18px;
  }
    

  /* Veg / Non-Veg toggle small */
  .veg-toggle {
    width: 90px !important;
    height: 34px !important;
  }

  .veg-toggle-knob {
    width: 26px !important;
    height: 26px !important;
    top: 4px !important;
  }

  .veg-toggle-label {
    font-size: 13px !important;
  }
}
`}
                </style>


                <div className="responsive-button-group menu-responsive-buttons-code" style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <div className="custom-switch-wrapper" style={{ position: "relative", width: "100%", zIndex: "9", backgroundColor: "white" }}>
                        <button
                            onClick={() => navigate("/")}
                            style={{
                                position: "absolute",
                                left: "-41%",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: "rgb(177, 92, 214)",
                                fontSize: isMobile ? "16px" : "18px",
                                display: isMobile ? "none" : "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            <ArrowBack style={{ fontSize: isMobile ? "20px" : "24px" }} />
                            Back
                        </button>

                        <div className="order-filter-buttons">
                            {/* DINE_IN Button */}
                            <button
                                onClick={() => handleOrderTypeClick("DINE_IN")}
                                className={`btn-filter ${orderType === "DINE_IN" ? "active-green" : "green"}`}
                            >
                                {/* <span className="btn-icon">🍽️</span> */}
                                <span className="btn-text">DINE IN</span>
                            </button>

                            <button
                                onClick={() => handleOrderTypeClick("TAKEAWAY")}
                                className={`btn-filter ${orderType === "TAKEAWAY" ? "active-red" : "red"}`}
                            >
                                {/* <span className="btn-icon">🥡</span> */}
                                <span className="btn-text">TAKEAWAY</span>
                            </button>

                            <button
                                onClick={() => handleOrderTypeClick("DELIVERY")}
                                className={`btn-filter ${orderType === "DELIVERY" ? "active-blue" : "blue"}`}
                            >

                                <span className="btn-text">DELIVERY</span>
                            </button>
                            <div style={{ margin: "10px 0" }}>
                                <input
                                    type="text"
                                    placeholder="Search dish..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{
                                        padding: "8px 12px",
                                        width: "100%",
                                        maxWidth: window.innerWidth < 768 ? "97px" : "300px", // 📱 mobile small
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </div>


                            {!isMobile && (
                                <div
                                    onClick={handleVegNonVegToggle}
                                    style={{
                                        width: "120px",
                                        height: "44px",
                                        borderRadius: "30px",
                                        background: isVegSelected
                                            ? "linear-gradient(145deg, #22c55e, #16a34a)"
                                            : "linear-gradient(145deg, #ef4444, #b91c1c)",
                                        position: "relative",
                                        cursor: "pointer",
                                        transition: "background 0.3s ease",
                                        boxShadow: "inset 0 2px 6px rgba(0,0,0,0.25)",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px",
                                    }}
                                >
                                    {/* Toggle Knob */}
                                    <div
                                        style={{
                                            width: "36px",
                                            height: "36px",
                                            borderRadius: "50%",
                                            background: "#ffffff",
                                            position: "absolute",
                                            top: "4px",
                                            left: isVegSelected ? "6px" : "77px",
                                            transition: "left 0.3s ease",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.35)",
                                        }}
                                    />

                                    {/* Label */}
                                    <span
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: 700,
                                            color: "#fff",
                                            position: "absolute",
                                            right: isVegSelected ? "10px" : "auto",
                                            left: isVegSelected ? "auto" : "10px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        {isVegSelected ? "VEG" : "NON-VEG"}
                                    </span>
                                </div>
                            )}

                            {/* MOBILE VIEW – ICON TYPE */}
                            {isMobile && (
                                <div style={{ display: "flex", gap: "10px", marginTop: "-2px" }}>
                                    {/* VEG ICON */}
                                    <div
                                        onClick={() => handleFilterClick("Veg")}
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #16a34a",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: isVegSelected ? "#e7f9ee" : "#fff", // highlight only when selected
                                            cursor: "pointer",
                                            borderRadius: "50%",
                                        }}
                                    >
                                        {/* Center Dot (always visible) */}
                                        <div
                                            style={{
                                                width: isVegSelected ? "16px" : "12px",      // 🔥 BIGGER
                                                height: isVegSelected ? "16px" : "12px",
                                                borderRadius: "50%",
                                                background: "#16a34a",
                                                // opacity: isVegSelected ? 1 : 0.5,
                                                transform: isVegSelected ? "scale(1.15)" : "scale(1)",
                                                boxShadow: isVegSelected
                                                    ? "none"             // ✨ glow
                                                    : "none",
                                                transition: "all 0.25s ease",
                                            }}
                                        />
                                    </div>

                                    {/* NON-VEG ICON */}
                                    <div
                                        onClick={() => handleFilterClick("Non-Veg")}
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #b91c1c",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: isNonVegSelected ? "#fdeaea" : "#fff", // highlight only when selected
                                            cursor: "pointer",
                                            borderRadius: "50%",
                                        }}
                                    >
                                        {/* Center Dot / Triangle */}
                                        <div
                                            style={{
                                                width: 0,
                                                height: 0,
                                                borderLeft: isNonVegSelected ? "9px solid transparent" : "7px solid transparent",
                                                borderRight: isNonVegSelected ? "9px solid transparent" : "7px solid transparent",
                                                borderBottom: isNonVegSelected
                                                    ? "16px solid #b91c1c"                       // 🔥 BIGGER
                                                    : "12px solid #b91c1c",
                                                // opacity: isNonVegSelected ? 1 : 0.5,
                                                transform: isNonVegSelected ? "scale(1.15)" : "scale(1)",
                                                filter: isNonVegSelected
                                                    ? "none" // ✨ glow
                                                    : "none",
                                                transition: "all 0.25s ease",
                                            }}
                                        />
                                    </div>
                                </div>
                            )}




                        </div>
                    </div>
                </div>
            </div>



            <div className="row " >


            </div>
            {/* <div className="offers-containers" style={{ marginTop: "-px" }}>


                {filteredDishes.map((item) => {
                     const isOutOfStock = Number(item.balanceQuantity) === 0;
                    return (
                        <div
                            key={item.dishId}
                            className="offers-cards"
                            style={{
                                position: "relative",
                                borderRadius: "14px",
                                overflow: "hidden",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                                background: "#fff",
                                marginBottom: "20px",
                            }}
                        >

                          
                            {item.discount > 0 && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        left: "10px",
                                        background: "#ee6521",
                                        color: "#fff",
                                        padding: "6px 16px",
                                        borderRadius: "50px",
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        zIndex: 5,
                                        boxShadow: "0 3px 8px rgba(0,0,0,0.20)",
                                    }}
                                >
                                    🏷️ Flat{item.discount}% OFF
                                </div>

                            )}

                           
                            <div style={{ position: "relative" }}>
                                <img
                                    src={item.dishImage}
                                    alt="Dish"
                                    style={{
                                        width: "100%",
                                        height: "220px",
                                        objectFit: "cover",
                                    }}
                                />
                                {isOutOfStock && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: "rgba(0,0,0,0.65)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#fff",
                                            fontSize: "22px",
                                            fontWeight: "700",
                                            zIndex: 4,
                                        }}
                                    >
                                        OUT OF STOCK
                                    </div>
                                )}
                                
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "10px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: "92%",
                                        background: "rgba(0, 0, 0, 0.45)",
                                        color: "#fff",
                                        padding: "8px 12px",
                                        fontSize: "14px",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        backdropFilter: "blur(4px)",
                                    }}
                                >
                                    {item.description?.trim()
                                        ? item.description
                                        : "Delicious & freshly prepared!"}
                                </div>
                            </div>

                           
                            <div style={{ padding: "15px" }}>

                               
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div>
                                       
                                        <span
                                            style={{
                                                flex: 1,
                                                wordBreak: "break-word",   // lamba word bhi break ho
                                                whiteSpace: "normal",      // next line allow
                                                lineHeight: "1.3",
                                                fontSize: "17px",
                                                fontWeight: "600"     // readability
                                            }}
                                        >
                                            {item.dishName}
                                        </span>

                                        
                                        <p
                                            style={{
                                                margin: 0,
                                                fontSize: "15px",
                                                fontWeight: "700",
                                                color: "#ee6521",
                                                letterSpacing: "0.5px",
                                                textTransform: "uppercase",
                                            }}
                                        >
                                            {item.companyName || "Maamaas Kitchen"}
                                        </p>
                                    </div>

                                    
                                    {item.tag === "Veg" ? (
                                        <div
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                border: "2px solid green",
                                                borderRadius: "2px",
                                                position: "relative",
                                                marginTop: "6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    background: "green",
                                                    borderRadius: "50%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                border: "2px solid red",
                                                borderRadius: "2px",
                                                position: "relative",
                                                marginTop: "6px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    background: "red",
                                                    borderRadius: "50%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                               
                                <div
                                    style={{
                                        marginTop: "12px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                   
                                    <div>
                                        <span
                                            style={{
                                                fontSize: "18px",
                                                color: "gray",
                                                position: "relative",
                                                marginRight: "12px",
                                            }}
                                        >
                                            <i className="fa-solid fa-indian-rupee-sign" /> {item.price}
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "14px",
                                                    left: 0,
                                                    width: "100%",
                                                    borderTop: "1px solid gray",
                                                }}
                                            ></span>
                                        </span>

                                        <span
                                            style={{
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                color: "#222",
                                            }}
                                        >
                                            <i className="fa-solid fa-indian-rupee-sign" />{" "}
                                            {item.effectivePrice.toFixed(2)}
                                        </span>
                                    </div>

                                  
                                    <i
                                        className="fa-regular fa-heart"
                                        style={{
                                            fontSize: "22px",
                                            cursor: "pointer",
                                            color: "#ee6521",
                                        }}
                                        onClick={() => handleAddToFavorites(item.dishId)}
                                    ></i>
                                </div>

                               
                                {userId && quantities[item.dishId] > 0 ? (
                                    <div
                                        className="d-flex justify-content-between align-items-center"
                                        style={{
                                            background: "#ee6521",
                                            borderRadius: "50px",
                                            padding: "3px 10px",
                                            width: "80%",
                                            margin: "15px auto 0",
                                        }}
                                    >
                                        <button
                                            className="btn"
                                            onClick={() => {
                                                openModal(item);
                                                decreaseQuantity(item);
                                            }}
                                            style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                color: "#fff",
                                                border: "none",
                                            }}
                                        >
                                            -
                                        </button>

                                        <span
                                            style={{
                                                fontSize: "22px",
                                                fontWeight: "bold",
                                                color: "#fff",
                                            }}
                                        >
                                            {quantities[item.dishId]}
                                        </span>

                                        <button
                                            className="btn"
                                            onClick={() => {
                                                openModal(item);
                                                increaseQuantity(item.dishId, item);
                                            }}
                                            style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                color: "#fff",
                                                border: "none",
                                            }}
                                        >
                                            +
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="btn d-block mx-auto"
                                        onClick={() => {
                                            if (!userId) return setShowLogin(true);
                                            openModal(item);
                                            setQuantities((prev) => ({ ...prev, [item.dishId]: 1 }));
                                            addToCart(item, 1);
                                        }}
                                        style={{
                                            width: "80%",
                                            marginTop: "15px",
                                            background: "#ee6521",
                                            color: "#fff",
                                            borderRadius: "50px",
                                        }}
                                    >
                                        Add To Cart
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}

            </div> */}

            <div className="offers-containers" style={{ marginTop: "-px" }}>
                {filteredDishes.map((item) => {
                    const isOutOfStock = Number(item.balanceQuantity) <= 0;

                    return (
                        <div
                            key={item.dishId}
                            className="offers-cards"
                            style={{
                                opacity: isOutOfStock ? 0.55 : 1,
                            }}
                        >
                            
                            <div
                                className="inner-box"
                                style={{
                                    position: "relative",
                                    pointerEvents: isOutOfStock ? "none" : "auto",
                                }}
                            >
                                {item.discount > 0 && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        left: "10px",
                                        background: "#ee6521",
                                        color: "#fff",
                                        padding: "6px 16px",
                                        borderRadius: "50px",
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        zIndex: 5,
                                        boxShadow: "0 3px 8px rgba(0,0,0,0.20)",
                                    }}
                                >
                                    🏷️ Flat{item.discount}% OFF
                                </div>

                            )}

                                {/* IMAGE */}
                                <img
                                    src={item.dishImage || "default-image.jpg"}
                                    alt="Dish"
                                    className="offer-image"
                                />

                                {/* OUT OF STOCK OVERLAY */}
                                {isOutOfStock && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            background: "rgba(0,0,0,0.6)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#fff",
                                            fontSize: "18px",
                                            fontWeight: "700",
                                            borderRadius: "12px",
                                            zIndex: 10,
                                        }}
                                    >
                                        OUT OF STOCK
                                    </div>
                                )}
                            </div>

                            <div
                                className="card-body"
                                style={{
                                    marginTop: "8px",
                                    padding: "15px",
                                    borderRadius: "10px",
                                }}
                            >
                                {/* TITLE ROW */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                    }}
                                >
                                    <h5
                                        style={{
                                            fontSize: "18px",
                                            marginBottom: "10px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <span
                                            style={{
                                                flex: 1,
                                                wordBreak: "break-word",
                                                lineHeight: "1.3",
                                                fontSize: "17px",
                                                fontWeight: "600",
                                            }}
                                        >
                                            {item.dishName}
                                        </span>

                                        {/* INFO BUTTON */}
                                        <div
                                            style={{
                                                marginLeft: "10px",
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "50%",
                                                backgroundColor: "#007bff",
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                                fontStyle: "italic",
                                                zIndex: 5,
                                            }}
                                            onClick={() => handleToggleTooltip(item.dishId)}
                                        >
                                            i

                                            {activeTooltip === item.dishId && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0, // full card cover
                                                        background: "rgba(0,0,0,0.45)", // transparent overlay
                                                        backdropFilter: "blur(6px)", // glass effect
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        zIndex: 20,
                                                        borderRadius: "12px",
                                                    }}
                                                    onClick={() => handleToggleTooltip(null)} // click anywhere to close
                                                >
                                                    <div
                                                        style={{
                                                            background: "rgba(255,255,255,0.95)",
                                                            padding: "22px",
                                                            borderRadius: "14px",
                                                            width: "80%",
                                                            maxWidth: "300px",
                                                            boxShadow: "0 15px 40px rgba(0,0,0,0.35)",
                                                            textAlign: "center",
                                                            position: "relative",
                                                            animation: "fadeIn 0.25s ease-in-out",
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {/* CLOSE BUTTON */}
                                                        <div
                                                            onClick={() => handleToggleTooltip(null)}
                                                            style={{
                                                                position: "absolute",
                                                                top: "8px",
                                                                right: "8px",
                                                                width: "15px",
                                                                height: "15px",
                                                                borderRadius: "50%",
                                                                backgroundColor: "#e53935",
                                                                color: "#fff",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontSize: "10px",
                                                                cursor: "pointer",
                                                                fontWeight: "600",
                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                                            }}
                                                        >
                                                            ✕
                                                        </div>

                                                        {/* DESCRIPTION */}
                                                        <div style={{ textAlign: "left" }}>
                                                            <div
                                                                style={{
                                                                    width: "35px",
                                                                    height: "2px",
                                                                    backgroundColor: "#ee6521",
                                                                    marginBottom: "8px",
                                                                    borderRadius: "2px",
                                                                }}
                                                            />

                                                            <p
                                                                style={{
                                                                    margin: 0,
                                                                    fontSize: "13px",
                                                                    color: "#444",
                                                                    lineHeight: "1.6",
                                                                    textAlign: "justify",
                                                                    wordBreak: "break-word",
                                                                }}
                                                            >
                                                                {item.description?.trim()
                                                                    ? item.description
                                                                    : "This dish is prepared with carefully selected ingredients and is known for its rich taste and aroma."}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>


                                        {/* VEG / NON-VEG */}
                                        <span
                                            style={{
                                                display: "inline-block",
                                                width: "18px",
                                                height: "18px",
                                                border: `2px solid ${item.tag === "Veg" ? "green" : "red"
                                                    }`,
                                                borderRadius: "2px",
                                                marginLeft: "12px",
                                                position: "relative",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "9px",
                                                    height: "9px",
                                                    backgroundColor:
                                                        item.tag === "Veg"
                                                            ? "green"
                                                            : "red",
                                                    borderRadius: "50%",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                            />
                                        </span>
                                    </h5>
                                </div>

                                {/* PRICE */}
                                <span className="d-flex justify-content-between">
                                    <span>
                                        <span
                                            style={{
                                                fontSize: "21px",
                                                color: "gray",
                                                position: "relative",
                                            }}
                                        >
                                            ₹{item.price}
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "15px",
                                                    left: 0,
                                                    width: "100%",
                                                    borderTop: "1px solid black",
                                                }}
                                            />
                                        </span>

                                        {item.effectivePrice !== undefined && (
                                            <span
                                                style={{
                                                    fontSize: "20px",
                                                    marginLeft: "15px",
                                                }}
                                            >
                                                ₹{item.effectivePrice.toFixed(2)}
                                            </span>
                                        )}
                                    </span>

                                    {/* FAVORITE */}
                                    <i
                                        className="fa-regular fa-heart fs-5"
                                        style={{
                                            marginTop: "10px",
                                            cursor: isOutOfStock
                                                ? "not-allowed"
                                                : "pointer",
                                            color: "#ee6521",
                                            pointerEvents: isOutOfStock
                                                ? "none"
                                                : "auto",
                                        }}
                                        onClick={() =>
                                            !isOutOfStock &&
                                            handleAddToFavorites(item.dishId)
                                        }
                                    />
                                </span>

                                <br />

                                {/* CART SECTION */}
                                {isOutOfStock ? (
                                    <button
                                        className="btn mt-2 d-block mx-auto"
                                        disabled
                                        style={{
                                            width: "80%",
                                            background: "#999",
                                            color: "#fff",
                                            cursor: "not-allowed",
                                        }}
                                    >
                                        Out of Stock
                                    </button>
                                ) : userId && quantities[item.dishId] > 0 ? (
                                    <div
                                        className="d-flex justify-content-between align-items-center border p-2 mt-2"
                                        style={{
                                            borderRadius: "50px",
                                            backgroundColor: "#ee6521",
                                            width: "80%",
                                            height: "37px",
                                            marginLeft: "38px",
                                        }}
                                    >
                                        <button
                                            className="btn"
                                            onClick={() => decreaseQuantity(item)}
                                            style={{ color: "#fff", fontSize: "25px" }}
                                        >
                                            -
                                        </button>

                                        <span
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: "bold",
                                                color: "#fff",
                                            }}
                                        >
                                            {quantities[item.dishId]}
                                        </span>

                                        <button
                                            className="btn"
                                            onClick={() =>
                                                increaseQuantity(item.dishId, item)
                                            }
                                            style={{ color: "#fff", fontSize: "25px" }}
                                        >
                                            +
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        className="btn mt-2 d-block mx-auto"
                                        onClick={() => {
                                            if (!userId) {
                                                setShowLogin(true);
                                                return;
                                            }
                                            openModal(item);
                                            setQuantities((prev) => ({
                                                ...prev,
                                                [item.dishId]: 1,
                                            }));
                                            addToCart(item, 1);
                                        }}
                                        style={{
                                            background: "#ee6521",
                                            color: "#fff",
                                            width: "80%",
                                        }}
                                    >
                                        Add To Cart
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                contentLabel="Add to Cart"
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                style={{
                    overlay: {
                        backgroundColor: "transparent",
                        pointerEvents: "none",
                    },
                    content: {
                        pointerEvents: "auto",
                        position: "absolute",
                        top: "92%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "80%",
                        maxWidth: "500px",
                        border: "none",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                        padding: "0px",
                        height: "90px",
                        borderRadius: "16px",
                        background: "transparent",
                        overflow: "visible",
                    },
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "12px 24px",
                        width: "100%",
                        fontWeight: "600",
                        color: "#333",
                        boxShadow: "0 8px 25px rgba(177, 92, 214, 0.2)",
                        height: "85px",
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #ffffff 0%, #f9f5ff 100%)",
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "4px",
                            background: "linear-gradient(90deg, #ee6521, #e091fa)",
                            borderRadius: "16px 16px 0 0",
                        }}
                    ></div>

                    {/* 🔻 LEFT SECTION */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {/* ICON — hide on mobile */}
                        <ShoppingCart
                            className="cart-icon"
                            style={{
                                fontSize: "32px",
                                color: "#ee6521",
                                marginRight: "18px",
                                filter: "drop-shadow(0 2px 4px rgba(177, 93, 198, 0.3))",
                            }}
                        />

                        {/* NUMBER OF ITEMS — show always */}
                        <div
                            className="cart-count-text"
                            style={{
                                marginRight: "20px",
                                fontSize: "22px",
                                fontWeight: "700",
                                color: "#5a2d69",
                            }}
                        >
                            ({cartItems.reduce((acc, item) => acc + (quantities[item.dishId] || 0), 0)}) Items
                        </div>
                    </div>

                    {/* TOTAL PRICE — show always */}
                    <div
                        className="cart-total-text"
                        style={{
                            marginRight: "20px",
                            fontSize: "22px",
                            fontWeight: "700",
                            color: "#5a2d69",
                        }}
                    >
                        Total: ₹
                        {cartItems
                            .reduce((acc, item) => {
                                const quantity = quantities[item.dishId] || 1;
                                const price = parseFloat(item.effectivePrice) || 0;
                                return acc + price * quantity;
                            }, 0)
                            .toFixed(2)}
                    </div>

                    {/* 🔻 VIEW CART BUTTON */}
                    <button
                        className="view-cart-btn"
                        style={{
                            borderRadius: "50px",
                            background: "linear-gradient(135deg, #ee6521 0%, #8a2be2 100%)",
                            color: "#fff",
                            padding: "10px 24px",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "16px",
                            boxShadow: "0 4px 12px rgba(177, 93, 198, 0.4)",
                            transition: "all 0.3s ease",
                        }}
                        onClick={handleViewCartClick}
                    >
                        View Cart
                    </button>
                </div>
            </Modal>

            {/* --- MOBILE RESPONSIVE CSS --- */}
            <style>
                {`
  @media (max-width: 600px) {
    /* Icon hide on mobile */
    .cart-icon {
      display: none !important;
    }

    /* Items and price slightly smaller on mobile */
    .cart-count-text,
    .cart-total-text {
      font-size: 16px !important;
      margin-right: 10px !important;
      font-weight: 600 !important;
    }

    /* View Cart button smaller on mobile */
    .view-cart-btn {
      padding: 6px 14px !important;
      font-size: 14px !important;
      border-radius: 40px !important;
    }
  }
`}
            </style>

        </div>
    );
};

export default MenuitemsTable;

